import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FaCheck } from 'react-icons/fa';
import styles from './Select.module.scss';

const SelectMenuItem = (props) => {
  const { active, option, multiselect, size } = props;
  const showCheckbox = multiselect && !option.clear;

  return (
    <div className={classNames(styles.selectItem, {
      [styles.active]: active && !multiselect,
      [styles.small]: size === 'small',
      [styles.inactive]: option.inactive || option.clear
    })} value={option.id}>
      <div className={styles.checkbox}>
        <input type='checkbox' className={styles.inputCheckbox} name={option.value} value={option.id} />
        {showCheckbox && <span className={classNames({[styles.active]: active}, styles.customCheckbox)}>
          {true && <FaCheck className={styles.check}/>}
        </span>}
      </div>
      <span className={classNames(styles.text, {
        [styles.multiselectText] : showCheckbox,
        [styles.active]: active && !multiselect
      })}>{props.prefix && <span>{props.prefix} </span>}{option.value}</span>
    </div>
  )
}

SelectMenuItem.propTypes = {
  option: PropTypes.object,
  /* Size of table: font, row height */
  size: PropTypes.oneOf(['small', 'default'])
}

export default SelectMenuItem;